import loadable from '@loadable/component';
import { DEFAULT_GT_SEARCH_PAGE_ID, DEFAULT_GT_SEARCH_PAGE_NAME } from 'src/common/constants/pages';
export class GroundTransportationSearchController {
  constructor() {
    this.bundles = ['gts'];
    this.component = loadable({
      resolved: {},
      chunkName() {
        return "GroundTransportationSearch";
      },
      isReady(props) {
        const key = this.resolve(props);
        if (this.resolved[key] !== true) {
          return false;
        }
        if (typeof __webpack_modules__ !== 'undefined') {
          return !!__webpack_modules__[key];
        }
        return false;
      },
      importAsync: () => import( /* webpackChunkName: "GroundTransportationSearch" */'src/common/views/ground-transportation/search'),
      requireAsync(props) {
        const key = this.resolve(props);
        this.resolved[key] = false;
        return this.importAsync(props).then(resolved => {
          this.resolved[key] = true;
          return resolved;
        });
      },
      requireSync(props) {
        const id = this.resolve(props);
        if (typeof __webpack_require__ !== 'undefined') {
          return __webpack_require__(id);
        }
        return eval('module.require')(id);
      },
      resolve() {
        if (require.resolveWeak) {
          return require.resolveWeak("src/common/views/ground-transportation/search");
        }
        return eval('require.resolve')("src/common/views/ground-transportation/search");
      }
    });
    this.pageId = DEFAULT_GT_SEARCH_PAGE_ID;
    this.path = '/ground-transfers/search';
    this.exact = true;
    this.routeName = 'GroundTransportationSearch';
    this.routeData = {
      rfrrNamespace: 'GT.SR',
      pageName: DEFAULT_GT_SEARCH_PAGE_NAME
    };
  }
  fetch(options) {
    if (!(options === null || options === void 0 ? void 0 : options.stores)) {
      return Promise.reject('GroundTransportationSearchController.fetch received an invalid StoreContainer');
    }
    const {
      query,
      stores
    } = options;
    const searchResults = stores.get('searchResults');
    if (!searchResults.searchCriteria) {
      return Promise.reject('Missing searchCriteria store');
    }
    // This line is necessary to render the <Sidebar/> component
    searchResults.searchCriteria.regionId = query.regionId;
    return Promise.resolve();
  }
  fetchPageData() {
    return Promise.resolve({
      title: 'Airport Transportation and Ground Transfers | Expedia',
      // TODO: Localize this title
      seo: {
        robots: 'noindex'
      },
      pageName: DEFAULT_GT_SEARCH_PAGE_NAME
    });
  }
}